import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelText as _vModelText, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modal formContainer" }
const _hoisted_2 = { class: "page_padding w-100" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between mb-4" }
const _hoisted_4 = { class: "fw_700 mb-0" }
const _hoisted_5 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_6 = { class: "form-check mb-4" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  class: "form-check-label",
  for: "noMaterialCheck"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "d-flex align-items-end mb-4" }
const _hoisted_11 = { class: "flex-grow-1 me-2" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = {
  class: "me-2",
  style: {"max-width":"170px"}
}
const _hoisted_16 = { class: "d-block fs_14 fw_700 mb-1" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "table table-striped"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "d-flex justify-content-end mt-4" }
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.elementName), 1),
        _createElementVNode("button", {
          type: "button",
          class: "btn-close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        })
      ]),
      (_ctx.globalErrors.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.globalErrors, (message, i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(message), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          id: "noMaterialCheck",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.noMaterial) = $event)),
          disabled: _ctx.isReadOnly,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onNoMaterialChanged()))
        }, null, 40, _hoisted_7), [
          [_vModelCheckbox, _ctx.noMaterial]
        ]),
        _createElementVNode("label", _hoisted_8, [
          _createVNode(_component_localized_text, {
            localizedKey: "This element has no material",
            text: "This element has no material"
          })
        ])
      ]),
      (!_ctx.noMaterial)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Material",
                  text: "Material",
                  class: "d-block fs_14 fw_700 mb-1"
                }),
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tempMaterialIdentifier) = $event)),
                  disabled: _ctx.isReadOnly
                }, [
                  _hoisted_13,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectableMaterials, (material) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: material.identifier,
                      value: material.identifier
                    }, _toDisplayString(material.materialName), 9, _hoisted_14))
                  }), 128))
                ], 8, _hoisted_12), [
                  [_vModelSelect, _ctx.tempMaterialIdentifier]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Percentage",
                    text: "Percentage",
                    class: "me-1"
                  }),
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.remainingPercentage > 0 ? 'text-danger' : 'text-success')
                  }, "(" + _toDisplayString(_ctx.remainingPercentage.toFixed(2)) + "%)", 3)
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  step: "0.01",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tempPercentage) = $event)),
                  disabled: _ctx.isReadOnly
                }, null, 8, _hoisted_17), [
                  [
                    _vModelText,
                    _ctx.tempPercentage,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              (!_ctx.isReadOnly)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-secondary",
                    disabled: _ctx.addDisabled,
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addMaterial()))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Add",
                      text: "Add"
                    })
                  ], 8, _hoisted_18))
                : _createCommentVNode("", true)
            ]),
            (_ctx.materials.length > 0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_19, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Material",
                          text: "Material"
                        })
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Percentage",
                          text: "Percentage"
                        })
                      ]),
                      _hoisted_20
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materials, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.materialIdentifier
                      }, [
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(item.materialName) + " ", 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rowErrors(item.materialName), (message, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "text-danger fs_14",
                              key: i
                            }, _toDisplayString(message), 1))
                          }), 128))
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.percentage.toFixed(2)) + "%", 1),
                        _createElementVNode("td", _hoisted_21, [
                          (!_ctx.isReadOnly)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-danger btn-sm",
                                onClick: ($event: any) => (_ctx.removeMaterial(index))
                              }, "x", 8, _hoisted_22))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["mb-4 fw_700", _ctx.totalOk ? 'text-success' : 'text-danger'])
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Total",
                text: "Total",
                class: "me-1"
              }),
              _createTextVNode(_toDisplayString(_ctx.totalPercentage.toFixed(2)) + "% ", 1)
            ], 2),
            _createVNode(_component_form_field, {
              type: "select",
              labelKey: "Country",
              labelValue: "Country",
              placeholderKey: "Country",
              placeholderValue: "Country",
              list: _ctx.allCountries,
              modelValue: _ctx.countryIdentifier,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.countryIdentifier) = $event)),
              readonly: _ctx.isReadOnly,
              class: "mb-3 w-100"
            }, null, 8, ["list", "modelValue", "readonly"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("button", {
          class: "btn btn-secondary me-2",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Cancel",
            text: "Cancel"
          })
        ]),
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-tertiary",
              disabled: !_ctx.isValid,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.save()))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Save",
                text: "Save"
              })
            ], 8, _hoisted_24))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}